export const SECTIONS_LIBRARY_TOUR = 'sections-library-tour';
export const SECTIONS_LIBRARY_TOUR_STEPS = ['addSection'];